import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTE_MISSIONS, routes } from './Router';

const isUnknownRoute = (routeNames: string[], pathname: string): boolean =>
    !routes.some((route) => pathname.startsWith(route));

const DefaultRedirect = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isUnknownRoute(routes, pathname)) {
            navigate(ROUTE_MISSIONS);
        }
    }, [pathname]);

    return null;
};

export default DefaultRedirect;
